module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '/*global define*/\n\ndefine("collections/Workbench", [\n    \'underscore\',\n    \'backbone\',\n    \'models/Workbench\'\n], function (_, Backbone, WorkbenchModel) {\n    \'use strict\';\n\n    var WorkbenchCollection = Backbone.Collection.extend({\n        model: WorkbenchModel\n    });\n\n    return WorkbenchCollection;\n});\n';

}
return __p
}